module.exports = __webpack_public_path__ + "img/dashcard.1b98155f.svg";